import React, { ReactNode, useState, Fragment, useEffect } from "react";

import { useSelector } from "react-redux";

import { UploadResult } from "@uppy/core";

import "../ProductsDrawer.less";

import "./index.less";

import { Form } from "antd";
import { DrawerProps } from "antd/lib/drawer";
import Table, { ColumnType } from "antd/lib/table";
import Button from "antd/lib/button";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Input from "antd/lib/input";
import TextArea from "antd/lib/input/TextArea";
import { Icon } from "@ant-design/compatible";
import Tooltip from "antd/lib/tooltip";
import Tag from "antd/lib/tag";
import Dropdown from "antd/lib/dropdown";
import Menu from "antd/lib/menu";
import Collapse from "antd/lib/collapse";
import Modal from "antd/lib/modal";
import Skeleton from "antd/lib/skeleton";

import ConfigProvider from "antd/lib/config-provider";

import ViewMoreOptionsIcon from "config/assets/Icons/ViewMoreOptionsIcon.svg";
import EmptyBundleProductsIcon from "@/Assets/ProductsPage/EmptyBundleProductsIcon.svg";
import EmptyProductPricingPlansIcon from "@/Assets/ProductsPage/EmptyProductPricingPlansIcon.svg";

import { checkCanMultiplePricingPlansFor } from "@/Components/Utils";

import {
	getCurrencySettings,
	currencyFormatter,
	percentageFormatter
} from "@/Utils/Currency";

import FileUpload, { UppyAllowedFileTypes } from "@/Components/UI/FileUpload";
import AddProductPricingPlanDrawer from "@/Components/ProductsPage/Drawers/AddProductPricingPlanDrawer";
import EditProductPricingPlanDrawer from "@/Components/ProductsPage/Drawers/EditProductPricingPlanDrawer";
import AddTaxCategoryDrawer from "@pages/TaxListPage/Drawers/TaxCategory";

import { DefaultErrorMessage, UppyFileMetaData } from "@/Contracts";
import {
	ProductFormValues,
	Product,
	ProductType,
	ProductBillingType,
	ProductPricingPlan,
	productBillingTypeOptions,
	BundleProduct,
	commonProductFormKeys,
	EditOrCloneProductDrawerMode,
	AddOrEditProductRequest,
	AddOrEditBundleRequest,
	ProductMiscEnums
} from "@/Contracts/Products";
import {
	capitalizeFirstLetter,
	copyToClipboardFromInputElement
} from "@/Contracts/Utils";
import {
	capitalizeAfterUnderscore,
	processCustomFieldFormValues
} from "@/Utils";
import {
	CustomField,
	CustomFieldMandatoryFieldDetailsValues
} from "@/Contracts/Settings";
import {
	AllRolePermissions,
	ManagerAndAdminRoleOnly,
	PricingPlanNames,
	UserRole
} from "@/Contracts/Users";

import ProductsActionCreators from "@/Actions/Products";
import UsersActionCreators from "@/Actions/User";

import { getBundledProductTableColumns } from "@/Components/ProductsPage/Drawers/bundledProductTableColumns";
import {
	handleMarginChange,
	handleMarkupMargin,
	handleMarkupChange
} from "@/Components/Utils/PricingCalculator";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { Divider } from "antd";
import { AddBundleChildToProductDrawer } from "@/Components/ProductsPage/Drawers/AddBundleChildToProductDrawer";

import ConfigureBundleChildProductDrawer from "@/Components/ProductsPage/Drawers//ConfigureBundleChildProductDrawer";
import RoleBasedDisplayWrapper from "@/Components//UI/RoleBasedDisplayWrapper";
import RenderCustomFieldFormItemV4 from "@molecules/ZRenderCustomFields/ZRenderCustomFieldsV4";
import { useTestEnvironment } from "@/Hooks";

import {
	ZInputNumber,
	ZSelect,
	ZCheckbox,
	ZTypography,
	ZIcon
} from "@atoms/index";

import ZInput from "@molecules/ZInput";
import { EInputNumberWidths } from "@atoms/ZInputNumber/interface";
import { EIcons } from "@atoms/ZIcon/interface";
import { EInputWidths } from "@molecules/ZInput/interface";
import ZMessage from "@molecules/ZMessage";
import { IOptionProps } from "@atoms/ZSelect/interface";
import ProductPricingOptions from "@/Components/DocumentsPage/Drawers/DocumentProductDrawers/DocumentProductDrawersComponents/ProductPricingOptions/ProductPricingOptions";
import { useComponentDidUpdate } from "@/Hooks";
import useDispatch from "@/Components/Utils/useDispatch";
import TaxSelect from "@molecules/TaxSelect";
import he from "he";
import { EFontWeights } from "@atoms/ZTypography/interface";
import { useFeatureAccess } from "@/Hooks/useFeatureAccess";
import { IHandlePricingIdChangeProps } from "@/Components/DocumentsPage/Drawers/DocumentProductDrawers/DocumentProductConfigureDrawerForm/DocumentProductConfigureDrawerForm";
import { GlobalState } from "@/Reducers/interface";
import ZDrawer from "@molecules/ZDrawer";
import {
	useCatalogPriceConversion,
	toDisplayPricingTriple,
	fromDisplayPricingTriple
} from "@/Hooks/useCatalogPriceConversion";
import useUpdateTemplateModal from "@/Hooks/Products/useUpdateTemplateModal";
import { EProductDrawerState } from "@/V2Components/pages/Drawers/Products/Product/interface";

const { ZText } = ZTypography;

export interface Props extends DrawerProps {
	readonly currentActiveProduct: Product | null;
	readonly mode: EditOrCloneProductDrawerMode | null;
	readonly onDrawerClose: () => void;
}

const formAlignment = {
	labelCol: { span: 6 },
	wrapperCol: { span: 18 }
};

const EditOrCloneProductDrawerForm: React.FC<Props> = props => {
	const priceConversion = useCatalogPriceConversion();
	const {
		isLoading,
		currentActiveDocument,
		taxCategoriesList,
		userData,
		addTaxCategoryDrawerOpen,
		unitOfMeasureMapping,
		customFieldListProduct
	} = useSelector((state: GlobalState) => ({
		isLoading: state.products.isLoading,
		currentActiveDocument: state.documents.currentActiveDocument,
		taxCategoriesList: state.user.taxCategoriesList,
		userData: state.user.userData,
		addTaxCategoryDrawerOpen: state.user.addTaxCategoryDrawerOpen,
		unitOfMeasureMapping:
			state.user.userCompany.settings.default_unit_of_measure_mapping,
		customFieldListProduct:
			state.customFields.customFieldListWithoutFormulaFields.item
	}));

	const [currentActiveProduct, setCurrentActiveProduct] =
		useState<Product | null>(null);

	const isFromEtilize = currentActiveProduct?.pricing.some(
		pricing => !!pricing.distributor_pricing_details
	);

	const [selectedDistributor, setSelectedDistributor] = useState<
		string | null
	>(currentActiveProduct?.selected_pricing_distributor ?? null);
	const [currentActiveProductImage, setCurrentActiveProductImage] = useState<
		string | null
	>(null);
	const [productImageList, setProductImageList] = useState<string[]>([]);
	const [bundledProductList, setBundledProductList] = useState<
		BundleProduct[]
	>([]);
	const [productPricingPlanList, setProductPricingPlanList] = useState<
		ProductPricingPlan[]
	>([]);
	const [
		currentActiveProductPricingPlan,
		setCurrentActiveProductPricingPlan
	] = useState<ProductPricingPlan | null>(null);
	const [productImageUploadModalOpen, setProductImageUploadModalOpen] =
		useState<boolean>(false);
	const [productImagePreviewModalOpen, setProductImagePreviewModalOpen] =
		useState<boolean>(false);
	const [
		addProductPricingPlanDrawerOpen,
		setAddProductPricingPlanDrawerOpen
	] = useState<boolean>(false);
	const [
		editProductPricingPlanDrawerOpen,
		setEditProductPricingPlanDrawerOpen
	] = useState<boolean>(false);
	const [searchProductsDrawerOpen, setSearchProductsDrawerOpen] =
		useState<boolean>(false);
	const [editChildBundleItem, setEditChildBundleItem] =
		useState<BundleProduct | null>(null);
	const [customFieldList, setCustomFieldList] = useState<CustomField[]>([]);
	const [isBundleProduct, setIsBundleProduct] = useState<boolean>(false);
	const [isHardwareProduct, setIsHardwareProduct] = useState<boolean>(false);
	const [showIndividualPricing, setShowIndividualPricing] = useState<boolean>(
		(currentActiveProduct &&
			currentActiveProduct?.show_individual_product_pricing) ??
			false
	);
	const [unitOfMeasure, setUnitOfMeasure] = useState<string | null>(
		currentActiveProduct?.unit_of_measure ?? null
	);

	const hasTaxEditPermission = useFeatureAccess(
		PricingPlanNames.IGNITE,
		UserRole.UserRole,
		[AllRolePermissions.TAX_SETUP_UPDATE]
	);

	const dispatch = useDispatch();
	const [form] = Form.useForm<ProductFormValues>();

	const handleBundleRowChange = (
		productId: string,
		data: Partial<BundleProduct>
	) => {
		setBundledProductList(
			bundledProductList.map(a =>
				a.item_id === productId ? { ...a, ...data } : a
			)
		);
	};

	const handleBundledProductSellPriceChange =
		(productId: string) => (sell_price?: number | string | null) => {
			if (typeof sell_price == "undefined" || sell_price === null) {
				return;
			}
			handleBundleRowChange(productId, {
				sell_price: Number(sell_price)
			});
		};

	const handleBundledProductCostPriceChange =
		(productId: string) =>
		(selected_cost_price?: number | string | null) => {
			if (
				typeof selected_cost_price == "undefined" ||
				selected_cost_price === null
			) {
				return;
			}
			handleBundleRowChange(productId, {
				selected_cost_price: Number(selected_cost_price)
			});
		};

	const handleBundledProductQuantityChange =
		(productId: string) => (quantity?: number | string | null) => {
			if (!quantity) {
				return;
			}

			handleBundleRowChange(productId, { quantity: Number(quantity) });
		};

	const handleBundledProductSetupPriceChange =
		(productId: string) =>
		(selected_setup_price?: number | string | null) => {
			if (
				typeof selected_setup_price === "undefined" ||
				selected_setup_price === null
			) {
				return;
			}

			handleBundleRowChange(productId, {
				selected_setup_price: Number(selected_setup_price)
			});
		};

	const handlePricingChange =
		(selectedVendorProductId: string) => (newPricingId: string) => {
			const selectedProduct = bundledProductList.find(
				a => a.item_id === selectedVendorProductId
			);

			const pricingList = selectedProduct?.item?.pricing;
			if (!pricingList?.length) {
				console.warn(`There are no pricing in this product to change`);
				return;
			}

			const selectedPricingData = pricingList?.find(
				a => a.id === newPricingId
			);
			if (!selectedPricingData) {
				console.warn(
					`Invalid Pricing Id: expected one of ${pricingList
						?.map(a => a.id)
						.join(", ")}, received ${newPricingId}`
				);
				return;
			}
			handleBundleRowChange(selectedVendorProductId, {
				selected_pricing_id: newPricingId,
				selected_cost_price: selectedPricingData?.cost_price,
				selected_setup_price: selectedPricingData?.setup_price,
				selected_billing_period:
					selectedPricingData?.billing_period ||
					ProductBillingType.OneTime,
				sell_price: selectedPricingData?.sell_price
			});
		};

	const handleBundleProductChildDelete = (currProductId: string) => () => {
		setBundledProductList(
			bundledProductList.filter(i => i.item_id !== currProductId)
		);
	};

	const handleEditDrawerOpen = (editChildBundleItem: BundleProduct) => () =>
		setEditChildBundleItem(editChildBundleItem);

	const toggleBundleProductOptional = (product: BundleProduct) => () =>
		handleBundleRowChange(product.item_id, {
			is_optional: !product.is_optional
		});

	const bundledProductTableColumns = (): ColumnType<BundleProduct>[] =>
		getBundledProductTableColumns({
			handlePricingChange: handlePricingChange,
			handleBundledProductSetupPriceChange:
				handleBundledProductSetupPriceChange,
			handleBundledProductCostPriceChange:
				handleBundledProductCostPriceChange,
			handleBundledProductSellPriceChange:
				handleBundledProductSellPriceChange,
			handleBundledProductQuantityChange:
				handleBundledProductQuantityChange,
			handleBundleProductChildDelete: handleBundleProductChildDelete,
			handleEditDrawerOpen: handleEditDrawerOpen,
			toggleBundleProductOptional: toggleBundleProductOptional,
			isReadonly:
				(currentActiveProduct?.read_only &&
					props.mode === EditOrCloneProductDrawerMode.EDIT) ??
				false
		});

	const resetState = () => {
		setCurrentActiveProductImage(null);
		setProductImageList([]);
		setBundledProductList([]);
		setProductPricingPlanList([]);
		setCurrentActiveProductPricingPlan(null);
		setProductImageUploadModalOpen(false);
		setProductImagePreviewModalOpen(false);
		setAddProductPricingPlanDrawerOpen(false);
		setEditProductPricingPlanDrawerOpen(false);
		setSearchProductsDrawerOpen(false);
	};

	const showAddTaxCategoryDrawer = () => {
		dispatch(UsersActionCreators.addTaxCategoryDrawerOpened());
	};

	const closeAddTaxCategoryDrawer = () => {
		dispatch(UsersActionCreators.addTaxCategoryDrawerClosed());
	};

	useEffect(() => {
		if (currentActiveProduct && props.visible) {
			setCustomFieldList(customFieldListProduct);
			setCurrentActiveProduct(props.currentActiveProduct);
			const {
				item_images,
				pricing,
				bundled_items,
				type,
				show_individual_product_pricing
			} = currentActiveProduct;
			setProductImageList(item_images);
			setProductPricingPlanList(
				pricing.filter(item => !item.distributor_pricing_details)
			);
			setBundledProductList(bundled_items ?? []);
			setIsBundleProduct(type === ProductType.Bundle);
			setIsHardwareProduct(type === ProductType.Hardware);
			setShowIndividualPricing(show_individual_product_pricing ?? false);
		}
	}, [props.visible, currentActiveProduct?.id]);

	const stopPropagation = (
		$event: React.MouseEvent<HTMLElement, MouseEvent> | Event
	) => {
		$event.stopPropagation();
	};

	const customEmptyBundleProductsTable = () => {
		return (
			<div className="empty-table">
				<EmptyBundleProductsIcon className="empty-table-icon" />
				<div className="empty-table-text">
					You have no products to display in this bundle.
				</div>
				<div className="empty-table-text">
					Click on 'Add Product' button to add a product to this
					bundle
				</div>
			</div>
		);
	};

	const showProductImageUploadModal = () => {
		setProductImageUploadModalOpen(true);
	};

	const closeProductImageUploadModal = () => {
		setProductImageUploadModalOpen(false);
	};

	const showPreviewProductImageModal = (productImage: string) => {
		setProductImagePreviewModalOpen(true);
		setCurrentActiveProductImage(productImage);
	};

	const closePreviewProductImageModal = () => {
		setProductImagePreviewModalOpen(false);
		setCurrentActiveProductImage(null);
	};

	const showAddProductPricingPlanDrawer = () => {
		setAddProductPricingPlanDrawerOpen(true);
	};

	const closeAddProductPricingPlanDrawer = () => {
		setAddProductPricingPlanDrawerOpen(false);
	};

	const showEditProductPricingPlanDrawer = (
		$event: any,
		productPricingPlan: ProductPricingPlan
	) => {
		stopPropagation($event.domEvent);
		setEditProductPricingPlanDrawerOpen(true);
		setCurrentActiveProductPricingPlan(productPricingPlan);
	};

	const closeEditProductPricingPlanDrawer = () => {
		setEditProductPricingPlanDrawerOpen(false);
		setCurrentActiveProductPricingPlan(null);
	};

	const showSearchProductsDrawer = () => {
		setSearchProductsDrawerOpen(true);
	};

	const closeSearchProductsDrawer = () => {
		setSearchProductsDrawerOpen(false);
	};

	const deleteProductPricingPlan = (
		$event: any,
		deleteProductPricingPlan: ProductPricingPlan
	) => {
		stopPropagation($event.domEvent);
		Modal.confirm({
			title: "Are you sure you want to remove this pricing plan?",
			onOk: () => {
				if (
					deleteProductPricingPlan.id &&
					deleteProductPricingPlan.id.length > 0
				) {
					setProductPricingPlanList(
						productPricingPlanList.filter(
							productPricingPlan =>
								productPricingPlan.id !==
								deleteProductPricingPlan.id
						)
					);
				} else if (
					deleteProductPricingPlan.session_id &&
					deleteProductPricingPlan.session_id.length
				) {
					setProductPricingPlanList(
						productPricingPlanList.filter(
							productPricingPlan =>
								productPricingPlan.session_id !==
								deleteProductPricingPlan.session_id
						)
					);
				}
			}
		});
	};

	const addProductPricingPlan = (
		addProductPricingPlan: ProductPricingPlan
	) => {
		setProductPricingPlanList(
			productPricingPlanList.concat(addProductPricingPlan)
		);
		setAddProductPricingPlanDrawerOpen(false);
		ZMessage.success("Pricing plan added successfully");
	};

	const editProductPricingPlan = (
		editProductPricingPlan: ProductPricingPlan
	) => {
		let updatedPricingPlanList = [...productPricingPlanList];
		if (editProductPricingPlan.id && editProductPricingPlan.id.length > 0) {
			updatedPricingPlanList = productPricingPlanList.map(
				productPricingPlan =>
					productPricingPlan.id === editProductPricingPlan.id
						? editProductPricingPlan
						: productPricingPlan
			);
		} else if (
			editProductPricingPlan.session_id &&
			editProductPricingPlan.session_id.length > 0
		) {
			updatedPricingPlanList = productPricingPlanList.map(
				productPricingPlan =>
					productPricingPlan.session_id ===
					editProductPricingPlan.session_id
						? editProductPricingPlan
						: productPricingPlan
			);
		}
		setProductPricingPlanList([...updatedPricingPlanList]);
		setEditProductPricingPlanDrawerOpen(false);
		ZMessage.success("Pricing plan edited successfully");
	};

	const deleteProductImage = (deleteProductImage: string) => {
		Modal.confirm({
			title: "Are you sure you want to remove this image?",
			onOk: () => {
				setProductImageList(
					productImageList.filter(
						productImage => productImage !== deleteProductImage
					)
				);
			}
		});
	};

	const toggleShowIndividualPrice = () => {
		setShowIndividualPricing(prevValue => !prevValue);
	};

	const uploadProductImage = async (
		result: UploadResult<UppyFileMetaData>
	) => {
		if (!!result?.successful?.length) {
			const productImages = result.successful.map(
				image => image.uploadURL
			);

			setProductImageList(prevState => [
				...prevState.concat(productImages)
			]);
		} else if (!!result?.failed?.length) {
			const failedError = result.failed[0].error;
			ZMessage.error(failedError);
		} else {
			ZMessage.error(DefaultErrorMessage);
		}
	};

	const onClose = () => {
		resetState();
		props.onDrawerClose();
	};

	const onFinish = (editOrCloneProductFormValues: ProductFormValues) => {
		const canHaveMultiplePricingPlans = checkCanMultiplePricingPlansFor(
			editOrCloneProductFormValues.type
		);

		const isValidPricingPlan =
			canHaveMultiplePricingPlans &&
			!productPricingPlanList?.length &&
			!isFromEtilize;

		if (isValidPricingPlan) {
			ZMessage.error("Please add atleast 1 pricing plan");
			return;
		}
		if (
			editOrCloneProductFormValues.type === ProductType.Bundle &&
			!bundledProductList?.length
		) {
			ZMessage.error("Please add atleast 1 product to bundle");
			return;
		}

		// new code
		// pricing values should retain irrespective of parent pricing or child pricing.
		if (!canHaveMultiplePricingPlans) {
			const productPricingPlan = new ProductPricingPlan();
			const defaultPricingPlan = currentActiveProduct?.pricing[0];
			productPricingPlan.id = defaultPricingPlan?.id || null;
			productPricingPlan.item_id = defaultPricingPlan?.item_id || null;
			productPricingPlan.session_id =
				defaultPricingPlan?.session_id || null;
			productPricingPlan.name =
				defaultPricingPlan?.name || ProductMiscEnums.DefaultPricing;
			productPricingPlan.description =
				defaultPricingPlan?.description || "";
			productPricingPlan.billing_period =
				editOrCloneProductFormValues.selected_billing_period ??
				editOrCloneProductFormValues.billing_period ??
				ProductBillingType.OneTime;
			Object.assign(
				productPricingPlan,
				fromDisplayPricingTriple(
					editOrCloneProductFormValues,
					priceConversion
				)
			);
			productPricingPlan.vendor_name =
				editOrCloneProductFormValues.vendor_name;
			productPricingPlan.vendor_sku_no =
				editOrCloneProductFormValues.vendor_sku_no;
			editOrCloneProductFormValues.pricing = [productPricingPlan];
		} else {
			editOrCloneProductFormValues.pricing = productPricingPlanList || [];
		}
		if (editOrCloneProductFormValues.type === ProductType.Bundle) {
			editOrCloneProductFormValues.bundled_items = [
				...bundledProductList
			];
		}
		editOrCloneProductFormValues.item_images =
			productImageList || new Array<string>();

		if (props.mode === EditOrCloneProductDrawerMode.EDIT) {
			editProduct(editOrCloneProductFormValues);
		} else if (props.mode === EditOrCloneProductDrawerMode.CLONE) {
			cloneProduct(editOrCloneProductFormValues);
		}
	};

	const editProduct = async (editProductFormValues: ProductFormValues) => {
		dispatch(ProductsActionCreators.showProductsLoader());
		try {
			if (currentActiveProduct) {
				const { ...editProductFormRequest } = editProductFormValues;

				let editProductRequest: AddOrEditProductRequest = {
					...currentActiveProduct,
					...editProductFormRequest,
					type: editProductFormValues.type
				};
				editProductFormValues.pricing.map(pricing => {
					pricing.sell_price = Number(pricing.sell_price);
					pricing.setup_price = Number(pricing.setup_price);
					return pricing;
				});
				editProductRequest.pricing = editProductFormValues.pricing;
				editProductRequest.bundled_items = bundledProductList.map(
					bundledProduct => {
						const newBundledProduct: AddOrEditBundleRequest = {
							...bundledProduct
						};
						delete newBundledProduct.item;
						return newBundledProduct;
					}
				);
				editProductRequest.tax_category_id =
					editProductFormValues.tax_category_id;
				editProductRequest.show_individual_product_pricing =
					showIndividualPricing;
				editProductRequest.should_add_setup_price_to_margin =
					editProductFormValues.should_add_setup_price_to_margin;
				editProductRequest.unit_of_measure =
					editProductFormValues.unit_of_measure;
				editProductRequest.mandatory_custom_field_check_require = true;
				const customFieldFormValues =
					editProductFormValues.custom_field_form_values;

				if (customFieldFormValues && customFieldList?.length > 0) {
					editProductRequest = {
						...editProductRequest,
						custom_fields: processCustomFieldFormValues(
							customFieldFormValues,
							customFieldList
						)
					};
				}

				editProductRequest.should_update_templates =
					updateExistingTemplateChecked;
				const editProductResponse = await dispatch(
					ProductsActionCreators.editProduct(editProductRequest)
				);

				setEditedProduct(editProductResponse.editProduct);

				if (
					updateExistingTemplateChecked &&
					!!editProductResponse.editProduct.templates?.length
				) {
					showModal(editProductResponse.editProduct.templates);
				} else {
					dispatch(
						ProductsActionCreators.updateProductDetails(
							editProductResponse.editProduct
						)
					);
					onClose();
					ZMessage.success("Product edited successfully");
				}
			}
		} catch (error) {
			console.error(error);
		} finally {
			setUpdateExistingTemplateChecked(false);
			dispatch(ProductsActionCreators.hideProductsLoader());
		}
	};

	const cloneProduct = async (cloneProductFormValues: ProductFormValues) => {
		dispatch(ProductsActionCreators.showProductsLoader());
		try {
			if (currentActiveProduct) {
				let cloneProductRequest = new AddOrEditProductRequest();
				cloneProductRequest.name = cloneProductFormValues.name;
				cloneProductRequest.description =
					cloneProductFormValues.description;
				cloneProductRequest.type = cloneProductFormValues.type;
				cloneProductRequest.product_category =
					cloneProductFormValues.product_category;
				cloneProductRequest.manufacturer =
					cloneProductFormValues.manufacturer;
				cloneProductRequest.manufacturer_part_no =
					cloneProductFormValues.manufacturer_part_no;
				cloneProductRequest.item_images =
					cloneProductFormValues.item_images;
				cloneProductRequest.tax_category_id =
					cloneProductFormValues.tax_category_id;
				cloneProductRequest.show_individual_product_pricing =
					showIndividualPricing;
				cloneProductRequest.should_add_setup_price_to_margin =
					cloneProductFormValues.should_add_setup_price_to_margin;
				cloneProductRequest.unit_of_measure =
					cloneProductFormValues.unit_of_measure;
				cloneProductRequest.mandatory_custom_field_check_require = true;
				cloneProductRequest.pricing =
					cloneProductFormValues.pricing.map(pricing => {
						pricing.id = null;
						pricing.item_id = null;
						pricing.cost_price = Number(pricing.cost_price || 0);
						pricing.sell_price = Number(pricing.sell_price || 0);
						pricing.setup_price = Number(pricing.setup_price || 0);
						pricing.margin = Number(pricing.margin || 0);
						pricing.markup = Number(pricing.markup || 0);
						return pricing;
					});
				cloneProductRequest.bundled_items =
					cloneProductFormValues.bundled_items ?? [];
				const customFieldFormValues =
					cloneProductFormValues.custom_field_form_values;
				if (customFieldFormValues && customFieldList?.length > 0) {
					cloneProductRequest = {
						...cloneProductRequest,
						custom_fields: processCustomFieldFormValues(
							customFieldFormValues,
							customFieldList
						)
					};
				}
				await dispatch(
					ProductsActionCreators.cloneProduct(cloneProductRequest)
				);
				onClose();
				ZMessage.success("Product cloned successfully");
			}
		} catch (error) {
			console.error(error);
		} finally {
			dispatch(ProductsActionCreators.hideProductsLoader());
		}
	};

	const getFieldValues = (): Record<commonProductFormKeys, any> => {
		const keys: commonProductFormKeys[] = [
			"selected_cost_price",
			"sell_price",
			"quantity",
			"should_add_setup_price_to_margin",
			"selected_setup_price",
			"type",
			"margin",
			"markup",
			"show_individual_product_pricing"
		];
		return form.getFieldsValue(keys) as Record<commonProductFormKeys, any>;
	};

	const onCostPriceChange = (newCostPrice?: number | string | null): void => {
		if (newCostPrice === undefined || newCostPrice === null) {
			return;
		}
		const values = getFieldValues();
		form.setFieldsValue(
			handleMarkupMargin(
				Number(newCostPrice),
				values.sell_price,
				values.quantity,
				values.should_add_setup_price_to_margin,
				values.selected_setup_price
			)
		);
	};

	const onMarginChange = (newMargin?: number | string | null): void => {
		if (
			newMargin === undefined ||
			newMargin === null ||
			form.getFieldValue("selected_cost_price") === 0
		) {
			return;
		}
		const values = getFieldValues();
		if (
			Number(newMargin) >= 100 &&
			Number(getFieldValues().selected_cost_price) !== 0
		) {
			return;
		}
		form.setFieldsValue(handleMarginChange(values, Number(newMargin)));
	};

	const updateCostPriceFromBundleItems = () => {
		const costPrice =
			bundledProductList?.reduce(
				(total, curr) =>
					curr.is_optional
						? total
						: total +
						  (curr.selected_cost_price || 0) * curr.quantity,
				0
			) || 0;

		copyToClipboardFromInputElement(costPrice + "");
		ZMessage.success("Value copied to clipboard");
		form.setFieldsValue({ selected_cost_price: costPrice });
	};

	const onMarkupChange = (newMarkup?: number | string | null): void => {
		if (
			newMarkup === undefined ||
			form.getFieldValue("selected_cost_price") === 0
		) {
			return;
		}
		const values = getFieldValues();
		form.setFieldsValue(handleMarkupChange(values, Number(newMarkup)));
	};

	const renderCostPriceInputGroup = () => {
		const values = form.getFieldsValue([
			"selected_cost_price",
			"sell_price",
			"quantity",
			"should_add_setup_price_to_margin",
			"selected_setup_price",
			"type",
			"vendor_name",
			"vendor_sku_no"
		]);

		const isBundleProduct = values?.type === ProductType.Bundle;

		const { currentActiveProduct } = props;
		const defaultPricing = currentActiveProduct?.pricing[0];
		const isReadonly = currentActiveProduct?.read_only;

		const { markup, margin } = handleMarkupMargin(
			values.selected_cost_price ?? defaultPricing?.cost_price ?? 0,
			values.sell_price ?? defaultPricing?.sell_price ?? 0,
			values.quantity,
			values.should_add_setup_price_to_margin,
			values.selected_setup_price
		);

		return (
			<Fragment>
				<Col span={24}>
					<Form.Item
						label="Cost Price"
						labelAlign="left"
						className="has-currency-addon-input"
						wrapperCol={{ span: 18 }}
					>
						<Input.Group>
							<Form.Item
								name="selected_cost_price"
								rules={[
									{
										required: true,
										validator: (_, value) => {
											if (Number(value) < 0) {
												return Promise.reject(
													new Error(
														"Invalid Entry. Cost price cannot be less than 0"
													)
												);
											}
											if (!value && value !== 0) {
												return Promise.reject(
													new Error(
														"Cost price cannot be empty"
													)
												);
											}
											return Promise.resolve();
										}
									}
								]}
								initialValue={priceConversion.toDisplay(
									defaultPricing?.cost_price || 0
								)}
							>
								<ZInputNumber
									width={EInputNumberWidths.lg}
									disabled={isReadonly}
									type="number"
									step=".01"
									min={0}
									className="has-currency-addon"
									onChange={onCostPriceChange}
									precision={2}
									addOnAfter={priceConversion.addonCurrency}
								/>
							</Form.Item>
							{unitOfMeasure && (
								<ZText className="whitespace-nowrap leading-8 ml-8">
									{unitOfMeasure}
								</ZText>
							)}
							{isBundleProduct && (
								<Button
									className={`sub-action-button ${
										!unitOfMeasure ? "ml-4" : ""
									}`}
									type="link"
									onClick={updateCostPriceFromBundleItems}
								>
									<ZText className="text-blue-5 active:text-blue-6">
										<ZIcon
											name={EIcons.COPY}
											size="sm"
											className="mx-1 stroke-current"
										/>
										Copy Product Total
									</ZText>
								</Button>
							)}
						</Input.Group>
					</Form.Item>
				</Col>
				<Col span={24}>
					<Form.Item
						label="Markup"
						labelAlign="left"
						hasFeedback={true}
						name="markup"
						rules={[
							{
								required: false,
								type: "number"
							}
						]}
						initialValue={markup}
						wrapperCol={{ span: 18 }}
					>
						<ZInputNumber
							width={EInputNumberWidths.xl}
							disabled={isReadonly}
							onChange={onMarkupChange}
							precision={2}
							step={0.1}
							addOnAfter={"%"}
						/>
					</Form.Item>
				</Col>
				<Col span={24}>
					<Form.Item
						label="Margin"
						labelAlign="left"
						hasFeedback={true}
						name="margin"
						rules={[
							{
								required: false,
								validator(_, value) {
									if (
										Number(value) >= 100 &&
										form.getFieldValue(
											"selected_cost_price"
										) > 0
									) {
										return Promise.reject(
											new Error(
												"Invalid Entry. Margin cannot be 100% unless cost price is 0"
											)
										);
									}
									return Promise.resolve();
								}
							}
						]}
						initialValue={margin}
					>
						<ZInputNumber
							width={EInputNumberWidths.xl}
							disabled={isReadonly}
							max={100}
							onChange={onMarginChange}
							precision={2}
							step={0.1}
							addOnAfter={"%"}
						/>
					</Form.Item>
				</Col>
				{currentActiveProduct?.type === ProductType.Hardware && (
					<>
						<Col span={24}>
							<Form.Item
								label="Vendor Name"
								labelAlign="left"
								hasFeedback={true}
								name="vendor_name"
								rules={[
									{
										required: false,
										message: "Enter Vendor Name"
									}
								]}
								initialValue={defaultPricing?.vendor_name ?? ""}
							>
								<ZInput
									width={EInputWidths.xl}
									disabled={isReadonly}
									placeholder="Enter Vendor Name"
									className="full-width"
								/>
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item
								label="Vendor SKU No"
								labelAlign="left"
								hasFeedback={true}
								name="vendor_sku_no"
								rules={[
									{
										required: false,
										message: "Please enter Vendor SKU No"
									}
								]}
								initialValue={
									defaultPricing?.vendor_sku_no ?? ""
								}
							>
								<ZInput
									width={EInputWidths.xl}
									disabled={isReadonly}
									placeholder="Please enter Vendor SKU No"
									className="full-width"
								/>
							</Form.Item>
						</Col>
					</>
				)}
			</Fragment>
		);
	};

	const onSetupPriceChange = (
		newSetupPrice?: number | string | null
	): void => {
		if (newSetupPrice === undefined || newSetupPrice === null) {
			return;
		}
		const values = getFieldValues();
		if (!values.should_add_setup_price_to_margin) {
			return;
		}
		const { markup, margin } = handleMarkupMargin(
			values.selected_cost_price,
			values.sell_price,
			values.quantity,
			values.should_add_setup_price_to_margin,
			Number(newSetupPrice)
		);
		form.setFieldsValue({
			markup: markup,
			margin: margin
		});
	};

	const onProductTypeChange = (productType?: string) => {
		if (productType) {
			const tax_category_id = taxCategoriesList?.find(
				taxCategory =>
					!taxCategory.disabled &&
					taxCategory.default_for_types?.findIndex(
						defaultProductType =>
							defaultProductType === (productType as ProductType)
					) > -1
			)?.id;
			const unit_of_measure = unitOfMeasureMapping?.find(
				mapping => mapping.item_type === productType
			)?.unit_of_measure;
			form.setFieldsValue({ tax_category_id, unit_of_measure });
			setIsBundleProduct(productType === ProductType.Bundle);
			setIsHardwareProduct(productType === ProductType.Hardware);
		}
	};

	const updateSellPriceFromBundleItems = () => {
		const sellPrice =
			bundledProductList?.reduce(
				(total, curr) =>
					curr.is_optional
						? total
						: total + (curr.sell_price || 0) * curr.quantity,
				0
			) || 0;

		copyToClipboardFromInputElement(sellPrice + "");
		ZMessage.success("Value copied to clipboard");
		form.setFieldsValue({ sell_price: sellPrice });
	};

	const updateSetupPriceFromBundleItems = () => {
		const totalSetupPrice =
			bundledProductList?.reduce(
				(total, product) =>
					product.is_optional
						? total
						: total + (product.selected_setup_price || 0),
				0
			) || 0;
		copyToClipboardFromInputElement(totalSetupPrice + "");
		ZMessage.success("Value copied to clipboard");
		form.setFieldsValue({ selected_setup_price: totalSetupPrice });
	};

	const onSellPriceChange = (newSellPrice?: number | string | null): void => {
		if (newSellPrice === undefined || newSellPrice === null) {
			return;
		}
		const values = getFieldValues();
		const { markup, margin } = handleMarkupMargin(
			values.selected_cost_price,
			Number(newSellPrice),
			values.quantity,
			values.should_add_setup_price_to_margin,
			values.selected_setup_price
		);
		form.setFieldsValue({ markup, margin });
	};

	const renderSellPriceInputGroup = () => {
		const isBundleProduct = getFieldValues().type === ProductType.Bundle;

		const { currentActiveProduct } = props;
		const isReadonly = currentActiveProduct?.read_only;
		const defaultPricing = currentActiveProduct?.pricing[0];
		const billingPeriodOptions = (
			Object.keys(productBillingTypeOptions) as ProductBillingType[]
		).map(value => {
			return {
				value,
				name: productBillingTypeOptions[value]
			};
		});

		return (
			<Fragment>
				<Col span={24}>
					<Form.Item
						label="Billing Period"
						labelAlign="left"
						hasFeedback={true}
						name="selected_billing_period"
						initialValue={
							currentActiveProduct?.pricing &&
							currentActiveProduct?.pricing[0] &&
							currentActiveProduct?.pricing[0]?.billing_period
								? currentActiveProduct?.pricing[0]
										?.billing_period
								: ProductBillingType.OneTime
						}
					>
						<ZSelect
							disabled={isReadonly}
							selectOptions={billingPeriodOptions}
						/>
					</Form.Item>
				</Col>
				<Col span={24}>
					<Form.Item
						label="Sell Price"
						labelAlign="left"
						className="has-currency-addon-input"
						wrapperCol={{ span: 18 }}
					>
						<Input.Group>
							<Form.Item
								name="sell_price"
								rules={[
									{
										required: true,
										message:
											"This is not a valid price for this product"
									}
								]}
								initialValue={priceConversion.toDisplay(
									defaultPricing?.sell_price || 0
								)}
							>
								<ZInputNumber
									width={EInputNumberWidths.lg}
									disabled={isReadonly}
									type="number"
									step=".01"
									min={0}
									className="has-currency-addon"
									onChange={onSellPriceChange}
									precision={2}
									addOnAfter={priceConversion.addonCurrency}
								/>
							</Form.Item>
							{unitOfMeasure && (
								<ZText className="whitespace-nowrap leading-8 ml-8">
									{unitOfMeasure}
								</ZText>
							)}
							{isBundleProduct && (
								<Button
									className={`sub-action-button ${
										!unitOfMeasure ? "ml-4" : ""
									}`}
									type="link"
									onClick={updateSellPriceFromBundleItems}
								>
									<ZText className="text-blue-5 active:text-blue-6">
										<ZIcon
											name={EIcons.COPY}
											size="sm"
											className="mx-1 stroke-current"
										/>
										Copy Product Total
									</ZText>
								</Button>
							)}
						</Input.Group>
					</Form.Item>
				</Col>
				<Col span={24}>
					<Form.Item
						label="Setup Fee"
						labelAlign="left"
						hasFeedback={true}
					>
						<Input.Group>
							<Form.Item
								name="selected_setup_price"
								rules={[
									{
										required: true,
										message:
											"Please enter product setup fee"
									}
								]}
								initialValue={priceConversion.toDisplay(
									defaultPricing?.setup_price || 0
								)}
							>
								<ZInputNumber
									width={EInputNumberWidths.lg}
									disabled={isReadonly}
									step=".01"
									type="number"
									min={0}
									className="has-currency-addon"
									onChange={onSetupPriceChange}
									precision={2}
									addOnAfter={priceConversion.addonCurrency}
								/>
							</Form.Item>
							{isBundleProduct && (
								<Button
									className={`sub-action-button ${
										!unitOfMeasure ? "ml-4" : ""
									}`}
									type="link"
									onClick={updateSetupPriceFromBundleItems}
								>
									<ZText className="text-blue-5 active:text-blue-6">
										<ZIcon
											name={EIcons.COPY}
											size="sm"
											className="mx-1 stroke-current"
										/>
										Copy Product Total
									</ZText>
								</Button>
							)}
						</Input.Group>
					</Form.Item>
				</Col>
			</Fragment>
		);
	};

	const onAddSetupPriceToMarginChange = (e: CheckboxChangeEvent): void => {
		const values = getFieldValues();
		const { markup, margin } = handleMarkupMargin(
			values.selected_cost_price,
			values.sell_price,
			values.quantity,
			e.target.checked,
			values.selected_setup_price
		);
		form.setFieldsValue({
			markup,
			margin
		});
	};

	const handleEditDrawerSubmit = async (productRequest: BundleProduct) => {
		const alreadyExists = bundledProductList?.find(
			product => product.item_id === productRequest.item_id
		)
			? true
			: false;

		if (!alreadyExists) {
			setBundledProductList([...bundledProductList, productRequest]);
		} else {
			const { ...bundledProductData } = productRequest;
			handleBundleRowChange(productRequest.item_id, bundledProductData);
		}
		setEditChildBundleItem(null);
		setProductImageList(
			Array.from(
				new Set([
					...productImageList,
					...productRequest.item.item_images
				])
			)
		);
	};

	const handleEditDrawerClose = () => {
		setEditChildBundleItem(null);
	};

	const getInitialTaxCategoryId = (): string | undefined => {
		if (
			currentActiveProduct?.tax_category_id &&
			currentActiveProduct?.tax_category_id?.length > 0
		) {
			return currentActiveProduct?.tax_category_id;
		} else if (
			currentActiveProduct?.type &&
			currentActiveProduct?.type?.length > 0
		) {
			return taxCategoriesList?.find(
				taxCategory =>
					!taxCategory.disabled &&
					taxCategory.default_for_types?.findIndex(
						productType =>
							productType === currentActiveProduct?.type
					) > -1
			)?.id;
		}
		return undefined;
	};

	const getInitialUnitOfMeasure = (): string | undefined => {
		if (!!currentActiveProduct?.unit_of_measure?.length) {
			return currentActiveProduct?.unit_of_measure;
		} else if (!!currentActiveProduct?.type?.length) {
			return unitOfMeasureMapping?.find(
				mapping => currentActiveProduct?.type === mapping.item_type
			)?.unit_of_measure;
		}
		return undefined;
	};

	const handleEtilizePricingChange = (event: IHandlePricingIdChangeProps) => {
		const pricingId = event?.radioChangeEvent?.target.value ?? null;

		setSelectedDistributor(pricingId);
	};

	const getProductFormItem = (customField: CustomField): ReactNode => {
		const isReadonly =
			currentActiveProduct?.read_only &&
			props.mode === EditOrCloneProductDrawerMode.EDIT;
		const canHaveMultiplePricingPlans = checkCanMultiplePricingPlansFor(
			form.getFieldValue("type")
		);
		switch (customField.system_field_id) {
			case "item_type": {
				const productTypes: IOptionProps[] = [
					{
						name: "Hardware",
						value: ProductType.Hardware
					},
					{
						name: "Software",
						value: ProductType.Software
					},
					{
						name: "Service",
						value: ProductType.Service
					},
					{
						name: "Labor",
						value: ProductType.Labor
					},
					{
						name: "Bundle",
						value: ProductType.Bundle
					}
				];

				return (
					<Fragment>
						<Col span={24}>
							<Form.Item
								name="type"
								label="Type"
								labelAlign="left"
								hasFeedback={true}
								rules={[
									{
										required: true,
										message: "Please select product type"
									}
								]}
								initialValue={currentActiveProduct?.type ?? ""}
							>
								<ZSelect<ProductType>
									disabled={isReadonly}
									allowClear={true}
									placeholder="Please select product type"
									onChange={onProductTypeChange}
									selectOptions={productTypes}
								/>
							</Form.Item>
						</Col>
						{isBundleProduct && (
							<Fragment>
								<Col
									span={24}
									className="table-page-container product-bundle-items-table-container margin-top-6px"
								>
									<ConfigProvider
										renderEmpty={
											customEmptyBundleProductsTable
										}
									>
										<Table
											rowClassName={(
												_record: BundleProduct
											) =>
												isReadonly
													? "disable-bundle-table"
													: ""
											}
											loading={isLoading}
											scroll={{
												x: true,
												scrollToFirstRowOnChange: true
											}}
											size="small"
											columns={bundledProductTableColumns()}
											dataSource={bundledProductList}
											pagination={false}
											rowKey="item_id"
											className="product-bundle-items-table mb-12"
											footer={() => {
												return isReadonly ? null : (
													<span
														className="link"
														onClick={
															showSearchProductsDrawer
														}
													>
														Add Product
													</span>
												);
											}}
										/>
									</ConfigProvider>
								</Col>
							</Fragment>
						)}
					</Fragment>
				);
			}
			case "item_item_images": {
				return (
					<Fragment>
						<Col span={6}>
							<div className="mt-6">Product Images:</div>
						</Col>
						<Col span={18} className="mb-8">
							<div className="product-image-upload-container">
								{productImageList &&
									productImageList.length > 0 &&
									productImageList.map(
										(productImage, index) => {
											return (
												<div
													key={index}
													className="product-image-container"
												>
													<img
														src={productImage}
														alt="Product"
														className="product-image"
													/>
													<div className="product-image-overlay">
														<Tooltip title="Preview product image">
															<Icon
																type="eye"
																onClick={() => {
																	showPreviewProductImageModal(
																		productImage
																	);
																}}
															/>
														</Tooltip>
														{!isReadonly && (
															<Tooltip title="Delete product image">
																<Icon
																	type="delete"
																	onClick={() => {
																		deleteProductImage(
																			productImage
																		);
																	}}
																/>
															</Tooltip>
														)}
													</div>
												</div>
											);
										}
									)}
								{!isReadonly && (
									<div
										className="product-image-container product-image-upload-button-container"
										onClick={showProductImageUploadModal}
									>
										<div className="product-image-upload-button">
											<div className="upload-icon">
												<Icon type="upload" />
											</div>
											<div className="upload-label">
												Upload
											</div>
										</div>
									</div>
								)}
							</div>
							{!isTestingEnvironment && (
								<FileUpload
									visible={productImageUploadModalOpen}
									maxNumberOfFiles={1}
									minNumberOfFiles={1}
									allowedFileTypes={[
										UppyAllowedFileTypes.Image
									]}
									maxFileSize={26214400}
									allowMultipleUploads={false}
									onClose={closeProductImageUploadModal}
									onComplete={uploadProductImage}
								/>
							)}
							{currentActiveProductImage &&
								currentActiveProductImage.length > 0 && (
									<Modal
										visible={productImagePreviewModalOpen}
										footer={null}
										onCancel={closePreviewProductImageModal}
										className="product-image-preview-modal"
									>
										<img
											src={currentActiveProductImage}
											alt="Product"
											className="product-image-preview"
										/>
									</Modal>
								)}
						</Col>
					</Fragment>
				);
			}
			case "item_description": {
				return (
					<Col span={24}>
						<Form.Item
							label="Description"
							labelAlign="left"
							hasFeedback={true}
							name="description"
							initialValue={he.decode(
								props.currentActiveProduct?.description ?? ""
							)}
						>
							<TextArea
								disabled={isReadonly}
								placeholder="Please enter product description"
								autoSize={{ minRows: 3 }}
								allowClear={true}
								className="zomentum-sm-textarea"
							/>
						</Form.Item>
					</Col>
				);
			}
			case "item_pricing": {
				return !!isFromEtilize && currentActiveProduct ? (
					<>
						<Col span={24}>
							<ProductPricingOptions
								pricing={currentActiveProduct.pricing}
								selectedPricingId={selectedDistributor}
								handlePricingIdChange={
									handleEtilizePricingChange
								}
								hideWarehouseOptions
								formAlignment={formAlignment}
							/>
						</Col>
						<Col span={formAlignment.labelCol.span} />
					</>
				) : (
					<Fragment>
						<Col span={24}>
							{canHaveMultiplePricingPlans && !isReadonly && (
								<Row>
									<Col span={24} className="align-right">
										<Button
											type="default"
											htmlType="button"
											loading={isLoading}
											onClick={
												showAddProductPricingPlanDrawer
											}
										>
											Add Plan
										</Button>
									</Col>
								</Row>
							)}
						</Col>
						{canHaveMultiplePricingPlans && (
							<Col span={24} className="mb-14">
								{(!productPricingPlanList ||
									(productPricingPlanList &&
										productPricingPlanList.length ===
											0)) && (
									<div className="align-center mt-6">
										<EmptyProductPricingPlansIcon />
										<div className="empty-component-text mt-6">
											You have no pricing plans to display
										</div>
										<div className="empty-component-text">
											Click on 'Add Plan' button to create
											a new one
										</div>
									</div>
								)}
								{productPricingPlanList &&
									productPricingPlanList.length > 0 && (
										<Collapse className="pricing-plan-container mt-4">
											{productPricingPlanList.map(
												(productPricingPlan, index) => {
													return (
														<Collapse.Panel
															key={index}
															className="pricing-plan"
															header={
																<Row
																	gutter={24}
																	align="middle"
																	className="pricing-plan-header"
																>
																	<Col
																		xs={20}
																		sm={22}
																		md={22}
																		lg={22}
																		xl={22}
																		xxl={22}
																		className="pricing-plan-name-billing-type-container"
																	>
																		<span className="pricing-plan-name">
																			{
																				productPricingPlan.name
																			}
																		</span>
																		<Tag className="pricing-plan-billing-type ml-4">
																			{capitalizeAfterUnderscore(
																				productPricingPlan.billing_period
																			)}
																		</Tag>
																	</Col>
																	<Col
																		xs={4}
																		sm={2}
																		md={2}
																		lg={2}
																		xl={2}
																		xxl={2}
																		className="align-right"
																	>
																		<Dropdown
																			overlay={
																				<Menu>
																					<Menu.Item
																						key="0"
																						onClick={$event =>
																							showEditProductPricingPlanDrawer(
																								$event,
																								productPricingPlan
																							)
																						}
																					>
																						<span>
																							{isReadonly
																								? "View Plan"
																								: "Edit Plan"}
																						</span>
																					</Menu.Item>
																					{!isReadonly && (
																						<Menu.Item
																							key="1"
																							className="red-text"
																							onClick={$event => {
																								deleteProductPricingPlan(
																									$event,
																									productPricingPlan
																								);
																							}}
																						>
																							<span>
																								Delete
																								Plan
																							</span>
																						</Menu.Item>
																					)}
																				</Menu>
																			}
																			trigger={[
																				"click",
																				"contextMenu"
																			]}
																		>
																			<div
																				onClick={
																					stopPropagation
																				}
																			>
																				<ViewMoreOptionsIcon className="cursor-pointer pricing-plan-menu-icon" />
																			</div>
																		</Dropdown>
																	</Col>
																</Row>
															}
														>
															<div className="pricing-plan-body">
																<Row
																	gutter={24}
																	align="middle"
																	className="pricing-plan-description-container"
																>
																	<Col
																		span={
																			12
																		}
																		className="pricing-plan-description"
																	>
																		{
																			productPricingPlan.description
																		}
																	</Col>
																	<Col
																		span={
																			12
																		}
																		className="pricing-plan-cost-container"
																	>
																		<div className="pricing-plan-cost">
																			<span className="text-bold">
																				{currencyFormatter(
																					productPricingPlan.sell_price
																				)}
																			</span>

																			<span>
																				{" "}
																				per
																				unit
																			</span>
																		</div>
																		{!!productPricingPlan.setup_price && (
																			<div className="pricing-plan-cost">
																				<span className="text-bold">
																					{currencyFormatter(
																						productPricingPlan.setup_price
																					)}
																				</span>
																				<span>
																					{" "}
																					one
																					time
																					setup
																					fee
																				</span>
																			</div>
																		)}
																	</Col>
																</Row>
															</div>
														</Collapse.Panel>
													);
												}
											)}
										</Collapse>
									)}
							</Col>
						)}
					</Fragment>
				);
			}
			case "item_product_category": {
				return (
					<Col span={24}>
						<Form.Item
							label="Category"
							labelAlign="left"
							hasFeedback={true}
							initialValue={
								currentActiveProduct?.product_category ?? ""
							}
							rules={[
								{
									required: false,
									message: "Please enter product category",
									whitespace: true
								}
							]}
							name="product_category"
						>
							<Input
								disabled={isReadonly}
								placeholder="Please enter product category"
							/>
						</Form.Item>
					</Col>
				);
			}
			case "item_manufacturer": {
				return (
					!isBundleProduct && (
						<Col span={24}>
							<Form.Item
								label="Manufacturer"
								labelAlign="left"
								hasFeedback={true}
								name="manufacturer"
								rules={[
									{
										required: false,
										message:
											"Please enter manufacturer name",
										whitespace: true
									}
								]}
								initialValue={
									currentActiveProduct?.manufacturer ?? ""
								}
							>
								<Input
									disabled={isReadonly}
									placeholder="Please enter manufacturer name"
								/>
							</Form.Item>
						</Col>
					)
				);
			}
			case "item_manufacturer_part_no": {
				return (
					!isBundleProduct && (
						<Col span={24}>
							<Form.Item
								label="Mfg. Number"
								labelAlign="left"
								hasFeedback={true}
								initialValue={
									currentActiveProduct?.manufacturer_part_no ??
									""
								}
								name="manufacturer_part_no"
								rules={[
									{
										required: false,
										message:
											"Please enter manufacturer part number",
										whitespace: true
									}
								]}
							>
								<Input
									disabled={isReadonly}
									placeholder="Please enter manufacturer part number"
								/>
							</Form.Item>
						</Col>
					)
				);
			}
			case "item_vendor_name": {
				return <Fragment />;
			}
			case "item_vendor_sku_no": {
				return <Fragment />;
			}
			case "item_tax_category_id": {
				const taxCategoriesListOptions = taxCategoriesList
					?.filter(taxCategory => !taxCategory.disabled)
					?.map(taxCategory => {
						return {
							value: taxCategory.id,
							name: taxCategory.name
						};
					});

				return (
					<Col span={24}>
						<Form.Item
							label="Tax Category"
							labelAlign="left"
							hasFeedback={true}
							name="tax_category_id"
							rules={[
								{
									required: true,
									message: "Please enter tax category"
								}
							]}
							initialValue={getInitialTaxCategoryId()}
						>
							<TaxSelect
								placeholder="Please select tax category"
								loading={isLoading}
								disabled={isLoading || isReadonly}
								dropdownRender={menu => (
									<div>
										{menu}
										<RoleBasedDisplayWrapper
											requiredRole={UserRole.PrimaryRole}
										>
											{hasTaxEditPermission && (
												<div
													className="add-entity-action"
													onMouseDown={$event => {
														$event.preventDefault();
													}}
													onClick={
														showAddTaxCategoryDrawer
													}
												>
													Add Tax Category
												</div>
											)}
										</RoleBasedDisplayWrapper>
									</div>
								)}
								selectOptions={taxCategoriesListOptions}
							/>
						</Form.Item>
					</Col>
				);
			}
			case "item_should_add_setup_price_to_margin": {
				const values = getFieldValues();
				const { margin } = handleMarkupMargin(
					values.selected_cost_price || 0,
					values.sell_price || 0,
					values.quantity || 1,
					!!values.should_add_setup_price_to_margin,
					values.selected_setup_price || 0
				);
				const marginAmount =
					((values.sell_price || 0) -
						(values.selected_cost_price || 0)) *
						(values.quantity || 1) +
					(!!values.should_add_setup_price_to_margin
						? values.selected_setup_price || 0
						: 0);

				const showPricingDetails =
					isHardwareProduct ||
					!!isFromEtilize ||
					(isBundleProduct && !showIndividualPricing);

				return (
					<Fragment>
						{!canHaveMultiplePricingPlans || isFromEtilize ? (
							<Fragment>
								<Col span={24} className="mb-6">
									<Row className="pricing-data-box">
										{isBundleProduct && (
											<Col span={24}>
												<Form.Item
													name="show_individual_product_pricing"
													initialValue={
														showIndividualPricing
													}
													valuePropName="checked"
												>
													<ZCheckbox
														disabled={isReadonly}
														onClick={
															toggleShowIndividualPrice
														}
														checkboxOption="Show individual product pricing"
													/>
												</Form.Item>
											</Col>
										)}
										<Col
											span={24}
											className={`${
												showPricingDetails
													? ""
													: "hidden"
											}`}
										>
											<Row>
												<Col span={24}>
													{renderCostPriceInputGroup()}
													<Divider className="mb-6" />
													{renderSellPriceInputGroup()}
													<Form.Item
														name="should_add_setup_price_to_margin"
														valuePropName="checked"
														initialValue={true}
													>
														<ZCheckbox
															disabled={
																isReadonly
															}
															onChange={
																onAddSetupPriceToMarginChange
															}
															checkboxOption="Add 'Setup Fee' to Margin"
														/>
													</Form.Item>
													<div className="margin-preview">
														<ZTypography.ZText
															weight={
																EFontWeights.MEDIUM
															}
														>
															Item Margin:
														</ZTypography.ZText>{" "}
														<span>
															{percentageFormatter(
																margin,
																100
															)}{" "}
															(
															{currencyFormatter(
																marginAmount
															)}
															)
														</span>
													</div>
												</Col>
											</Row>
										</Col>
									</Row>
								</Col>
							</Fragment>
						) : (
							<Col span={24}>
								<Form.Item
									name="should_add_setup_price_to_margin"
									valuePropName="checked"
									initialValue={true}
								>
									<ZCheckbox
										disabled={isReadonly}
										onChange={onAddSetupPriceToMarginChange}
										checkboxOption="Add 'Setup Fee' to Margin"
									/>
								</Form.Item>
								<div className="margin-preview mt-6 mb-6">
									<strong>Item Margin:</strong>{" "}
									<span>
										{percentageFormatter(margin, 100)} (
										{currencyFormatter(marginAmount)})
									</span>
								</div>
							</Col>
						)}
					</Fragment>
				);
			}
			case "item_show_individual_product_pricing":
			case "item_tax_type":
				return <Fragment />;
			case "item_unit_of_measure": {
				const uomOptions = customField.allowed_dropdown_values?.map(
					value => ({
						value,
						name: value
					})
				);
				return (
					<Col span={24}>
						<Form.Item
							label="UOM"
							labelAlign="left"
							hasFeedback={true}
							name="unit_of_measure"
							initialValue={getInitialUnitOfMeasure()}
							rules={[
								{
									required:
										customField?.mandatory_field_details?.[
											CustomFieldMandatoryFieldDetailsValues
												.FOR_UI
										],
									message: "Please select the unit of measure"
								}
							]}
						>
							<ZSelect<string>
								placeholder="Please select the unit of measure"
								onChange={value =>
									setUnitOfMeasure(value?.toString())
								}
								allowClear
								selectOptions={uomOptions}
							/>
						</Form.Item>
					</Col>
				);
			}
			default: {
				const productCustomField =
					currentActiveProduct?.custom_fields?.find(
						field => field.id === customField.id
					);
				const values = productCustomField?.values;
				const isDataEditable = customField?.is_data_editable_field;
				return (
					<Col span={24}>
						<RenderCustomFieldFormItemV4
							form={form}
							customField={customField}
							values={values}
							isReadonly={
								(currentActiveProduct?.read_only &&
									props.mode ===
										EditOrCloneProductDrawerMode.EDIT) ||
								!isDataEditable
							}
							formAlignment={formAlignment}
							customFieldList={customFieldList}
						/>
					</Col>
				);
			}
		}
	};

	const updatePricingInfoFromEtilize = () => {
		if (!currentActiveProduct) {
			ZMessage.error("No Etilize product selected");
			return;
		}

		const selectedPricing = currentActiveProduct.pricing.find(
			pricing => pricing.id === selectedDistributor
		);

		if (!selectedPricing) {
			// if user selects Custom plan, then reset these fields
			form.setFieldsValue({
				selected_cost_price: 0,
				sell_price: 0,
				vendor_sku_no: "",
				vendor_name: "",
				markup: 0,
				margin: 0,
				selected_setup_price: 0
			});

			return;
		}

		const values = form.getFieldsValue([
			"selected_cost_price",
			"sell_price",
			"quantity",
			"should_add_setup_price_to_margin",
			"selected_setup_price",
			"type",
			"vendor_name",
			"vendor_sku_no"
		]);

		const display = toDisplayPricingTriple(
			selectedPricing,
			priceConversion
		);

		const { markup, margin } = handleMarkupMargin(
			display.cost_price,
			display.sell_price,
			values.quantity,
			values.should_add_setup_price_to_margin,
			display.setup_price
		);

		form.setFieldsValue({
			selected_cost_price: display.cost_price,
			sell_price: display.sell_price,
			vendor_sku_no: selectedPricing.vendor_sku_no,
			vendor_name: selectedPricing.vendor_name,
			markup: markup,
			margin: margin,
			selected_setup_price: display.setup_price
		});
	};

	useComponentDidUpdate(() => {
		updatePricingInfoFromEtilize();
	}, [selectedDistributor]);

	const isTestingEnvironment = useTestEnvironment();

	const isReadonly =
		currentActiveProduct?.read_only &&
		props.mode === EditOrCloneProductDrawerMode.EDIT;

	useEffect(() => {
		const preventFormSubmit = (e: any) => {
			if (e.key === "Enter") {
				e.preventDefault();
			}
		};
		if (productImageUploadModalOpen) {
			document.addEventListener("keypress", preventFormSubmit);
		}
		return () => {
			document.removeEventListener("keypress", preventFormSubmit);
		};
	}, [productImageUploadModalOpen]);

	useEffect(() => {
		setCurrentActiveProduct(props.currentActiveProduct);
	}, [props.currentActiveProduct]);

	const [updateExistingTemplateChecked, setUpdateExistingTemplateChecked] =
		useState<boolean>(false);

	const { setEditedProduct, showModal, TemplateModal } =
		useUpdateTemplateModal(
			currentActiveProduct,
			EProductDrawerState.EDITORCLONE,
			onClose
		);

	const handleTaxCategoryDrawerOnSubmit = (id: string) => {
		form.setFieldsValue({
			tax_category_id: id
		});
	};

	return (
		<>
			{TemplateModal}
			<ZDrawer
				visible={props.visible}
				closable={true}
				destroyOnClose={true}
				onClose={onClose}
				className="edit-product-drawer zomentum-drawer"
				title={
					<Row>
						<Col span={24}>
							<div className="drawer-title-container">
								<div className="drawer-title">
									{capitalizeFirstLetter(props.mode)} Product
								</div>
							</div>
						</Col>
					</Row>
				}
			>
				<AddProductPricingPlanDrawer
					visible={addProductPricingPlanDrawerOpen}
					onClose={closeAddProductPricingPlanDrawer}
					isLoading={isLoading}
					onSubmit={addProductPricingPlan}
				/>
				<EditProductPricingPlanDrawer
					visible={editProductPricingPlanDrawerOpen}
					onClose={closeEditProductPricingPlanDrawer}
					isLoading={isLoading}
					onSubmit={editProductPricingPlan}
					currentActiveProductPricingPlan={
						currentActiveProductPricingPlan
					}
					isReadonly={!!isReadonly}
				/>
				<AddBundleChildToProductDrawer
					visible={searchProductsDrawerOpen}
					onClose={closeSearchProductsDrawer}
					onSubmit={handleEditDrawerSubmit}
					currentActiveDocument={currentActiveDocument}
					isFromProductsPage={true}
					bundledProductList={bundledProductList}
				/>
				<ConfigureBundleChildProductDrawer
					currentActiveProduct={editChildBundleItem}
					visible={!!editChildBundleItem}
					onSubmit={handleEditDrawerSubmit}
					onClose={handleEditDrawerClose}
					currentActiveDocument={currentActiveDocument}
					isReadonly={isReadonly}
					bundledProductList={bundledProductList}
				/>
				<Skeleton
					loading={!currentActiveProduct?.id?.length}
					active
					paragraph={{ rows: 12 }}
				>
					<AddTaxCategoryDrawer
						visible={addTaxCategoryDrawerOpen}
						onClose={closeAddTaxCategoryDrawer}
						handleTaxCategoryDrawerOnSubmit={
							handleTaxCategoryDrawerOnSubmit
						}
					/>
					{userData?.role &&
						ManagerAndAdminRoleOnly.indexOf(userData?.role) >
							-1 && (
							<Form
								form={form}
								layout="horizontal"
								labelCol={formAlignment.labelCol}
								wrapperCol={formAlignment.wrapperCol}
								onFinish={onFinish}
								scrollToFirstError={{
									block: "start"
								}}
								className="edit-product-drawer-form"
							>
								<Row className="drawer-form-container pb-4">
									<Col span={24}>
										<Form.Item
											label="Name"
											labelAlign="left"
											hasFeedback={true}
											name="name"
											rules={[
												{
													required: true,
													message:
														"Please enter product name",
													whitespace: true
												}
											]}
											initialValue={
												currentActiveProduct?.name ?? ""
											}
										>
											<Input
												disabled={isReadonly}
												placeholder="Please enter product name"
											/>
										</Form.Item>
									</Col>
									{customFieldList?.length > 0 &&
										customFieldList.map(
											(customField, index) => {
												return (
													<Fragment key={index}>
														{getProductFormItem(
															customField
														)}
													</Fragment>
												);
											}
										)}
								</Row>

								<div className="ant-drawer-footer">
									<div
										className={`w-full flex justify-start items-center`}
									>
										{props.mode ===
											EditOrCloneProductDrawerMode.EDIT &&
											!props.currentActiveProduct
												?.read_only && (
												<ZCheckbox
													className={`pl-2`}
													onChange={e =>
														setUpdateExistingTemplateChecked(
															e.target.checked
														)
													}
													checked={
														updateExistingTemplateChecked
													}
												>
													Update Values in existing
													templates
												</ZCheckbox>
											)}
									</div>

									<Button
										type="default"
										htmlType="button"
										onClick={onClose}
										disabled={isLoading}
										className={isReadonly ? "" : "mr-4"}
									>
										{isReadonly ? "Close" : "Cancel"}
									</Button>
									{!isReadonly && (
										<Button
											data-testid="save-button"
											type="primary"
											htmlType="submit"
											disabled={isLoading}
											loading={isLoading}
										>
											Save
										</Button>
									)}
								</div>
							</Form>
						)}
				</Skeleton>
			</ZDrawer>
		</>
	);
};

export default EditOrCloneProductDrawerForm;
